import { FETCH_CHAT_COUNT } from "./index";

export const setChatCount = (payload) => {
  return {
    type: FETCH_CHAT_COUNT,
    payload: payload,
  };
};
